// Facebook Pixel initialization and SPA tracking
export function initFacebookPixel(pixelId) {
  if (!pixelId || window.__fbPixelInitialized) return;

  // fbq bootstrap
  (function(f,b,e,v,n,t,s){
    if(f.fbq) return; n=f.fbq=function(){ n.callMethod ?
      n.callMethod.apply(n,arguments) : n.queue.push(arguments) };
    if(!f._fbq) f._fbq=n; n.push=n; n.loaded=!0; n.version='2.0';
    n.queue=[]; t=b.createElement(e); t.async=!0; t.src=v;
    s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  // init & initial page view
  if (typeof window.fbq === 'function') {
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
    window.__fbPixelInitialized = true;
  }
}

export function trackSpaPageViewsFB() {
  const track = () => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  };

  let lastPath = window.location.pathname + window.location.search;

  const onChange = () => {
    const now = window.location.pathname + window.location.search;
    if (now !== lastPath) { lastPath = now; track(); }
  };

  const wrap = (fn) => function() {
    const res = fn.apply(this, arguments);
    onChange();
    return res;
  };

  if (window.history.pushState) window.history.pushState = wrap(window.history.pushState);
  if (window.history.replaceState) window.history.replaceState = wrap(window.history.replaceState);
  window.addEventListener('popstate', onChange);
}


